import { UI, HStack, Stack, VStack } from '@genial/components';
import { BoxBorder, Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

import { CardItem, CardItemLoading } from './CardItem';
import { columnWidths } from './constants';

import { CardHeroDataProps } from '.';

export const ContentDesktop: React.FC<CardHeroDataProps> = ({ data, isLoading }) => {
  const renderContent = () => {
    if (!data || isLoading) {
      return (
        <>
          {Object.values(columnWidths).map((width, index) => (
            <CardItemLoading key={index.toString()} width={width} />
          ))}
        </>
      );
    }

    return (
      <>
        <CardItem
          width={columnWidths.name}
          label={'Nome'}
          value={
            <HStack space={Spacing['inline.xxxs']} alignItems="center">
              <UI.Avatar
                testId="client-avatar"
                textColor="neutral.white"
                bgColor={'brand.primary.light'}
                initials={data.initials}
              />
              <UI.Text>{data.nomeCliente}</UI.Text>
            </HStack>
          }
        />
        <CardItem width={columnWidths.email} label={'E-mail'} value={data.email} />
        <CardItem width={columnWidths.person} label={'Pessoa'} value={data.tipoPessoaNormalized} />
        <CardItem
          width={columnWidths.sinacorAccount}
          disabled
          label={'Conta sinacor'}
          value={data.contaSinacorComDigito}
        />
        <CardItem
          width={columnWidths.custodyAccount}
          label={'Conta de custódia'}
          value={data.contaSuperPNPComDigito}
        />
        <CardItem width={columnWidths.accountBP} label={'Conta BP'} value={data.contaBPComDigito} />
        <CardItem
          width={columnWidths.promotionalRestriction}
          label={'Restrição Promocional'}
          value={
            data.promotionalRestriction.hasRestriction ? (
              <VStack space={Spacing['stack.quarck']}>
                <UI.Text>{data.promotionalRestriction.statusText}</UI.Text>
                <UI.Text fontSize={Typography['fontsize.xs']} color="neutral.medium">
                  Val.{' '}
                  {Utils.Mask.DateFormat(
                    data.promotionalRestriction.blackListExpirationDate,
                    'dd/MM/yyyy'
                  )}
                </UI.Text>
              </VStack>
            ) : (
              data.promotionalRestriction.statusText
            )
          }
        />
      </>
    );
  };

  return (
    <UI.Shadow level={1} borderRadius={BoxBorder.heavy}>
      <Stack
        width={'100%'}
        direction="row"
        borderRadius={BoxBorder.heavy}
        backgroundColor={Color.background}
        paddingX={Spacing['inline.xxxs']}
        paddingY={Spacing['inline.xxs']}
        alignItems={'center'}>
        {renderContent()}
      </Stack>
    </UI.Shadow>
  );
};
